import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Toaster } from "../components/ui/sonner";
import Navigation from "../components/Navigation";
import Footer from "../components/Footer";
import CookieBanner from "../components/CookieBanner";
import { useLenis } from "../hooks/useLenis";

export default function PageShell({ children, className = "" }) {
  useLenis();
  const { pathname, hash } = useLocation();

  // Scroll to top on route change unless there's a hash
  useEffect(() => {
    if (hash) return;
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname, hash]);

  // Smooth-scroll to a #hash if present (e.g. /contact#form)
  useEffect(() => {
    if (!hash) return;
    const t = setTimeout(() => {
      const el = document.querySelector(hash);
      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 300);
    return () => clearTimeout(t);
  }, [hash, pathname]);

  return (
    <div className={`relative min-h-screen bg-canvas text-primary-x ${className}`}>
      <Navigation />
      <main>{children}</main>
      <Footer />
      <CookieBanner />
      <Toaster position="bottom-right" richColors closeButton />
    </div>
  );
}
